module.exports = __webpack_public_path__ + "files/c45152a20fcaa8ae5d5611e947399dcc.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Lato-regular.ttf
// module id = 766
// module chunks = 60